import Vue from 'vue';

export default new Vue({
  methods: {
    addToList(contact) {
      this.$emit('contacts-add-to-list', contact);
    },

    edit(contact) {
      this.$emit('contacts-on-edit', contact);
    },

    update(contact) {
      this.$emit('contacts-on-update', contact);
    },

    loaded() {
      this.$emit('contacts-list-loaded');
    },
  },
});
